module.exports = __webpack_public_path__ + "static/img/logo-dark.2baae3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-dark.png
// module id = 299
// module chunks = 33